
    <template>
      <section class="doc-article monkey-view-doc">
        <h1>Grid 栅格</h1>
<p>24栅格系统。</p>
<h2 id="gai-shu" class="anchor-title">概述 <a class="header-anchor" href="#gai-shu">#</a></h2>
<p>栅格系统采用24栅格的布局，将一行区域进行24等分，这样可以轻松解决绝大部分布局问题，使页面排版更美观、舒适。</p>
<p>栅格系统定义两个概念，即行<code>row</code>和列<code>col</code>，具体使用如下：</p>
<ul>
<li>
<p>使用<code>row</code>在水平方向创建一行</p>
</li>
<li>
<p>使用<code>col</code>在垂直方向创建一列</p>
</li>
<li>
<p>通过<code>col</code>的<code>span</code>属性指定列的范围，如果不主动设置，内部会计算平分行空间</p>
</li>
<li>
<p>一行可以分多列，即可以使用多个<code>col</code>，总和不能超过24</p>
</li>
<li>
<p>在每个<code>col</code>中填入自己的内容</p>
</li>
</ul>
<h2 id="dai-ma-shi-li" class="anchor-title">代码示例 <a class="header-anchor" href="#dai-ma-shi-li">#</a></h2>
<code-wrap id="JCSY">
                <template slot="description"><p>基础使用方法。<code>col</code>必须放在 <code>row</code>里边。可以通过 <code>span</code>属性控制列的范围。不主动设置 <code>span</code>属性时内部会自动计算空间设置列范围。<code>span</code>为0时相当于 <code>display: none;</code>。</p>
</template>
                <template slot="title">基础使用 <a href="#JCSY" data-title="基础使用">#</a></template>
                <template slot="source"><monkey-view-demo0 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;div class=&quot;doc-grid-row-wrap&quot;&gt;
        &lt;Row class=&quot;doc-grid-row&quot;&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;24: 100%&lt;/div&gt;&lt;/Col&gt;
        &lt;/Row&gt;
    &lt;/div&gt;
    &lt;div class=&quot;doc-grid-row-wrap&quot;&gt;
        &lt;Row class=&quot;doc-grid-row&quot;&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;12: 50%&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;12: 50%&lt;/div&gt;&lt;/Col&gt;
        &lt;/Row&gt;
    &lt;/div&gt;
    &lt;div class=&quot;doc-grid-row-wrap&quot;&gt;
        &lt;Row class=&quot;doc-grid-row&quot;&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;8: 33.33%&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;8: 33.33%&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;8: 33.33%&lt;/div&gt;&lt;/Col&gt;
        &lt;/Row&gt;
    &lt;/div&gt;
    &lt;div class=&quot;doc-grid-row-wrap&quot;&gt;
        &lt;Row class=&quot;doc-grid-row&quot;&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;6: 25%&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;6: 25%&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;6: 25%&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;6: 25%&lt;/div&gt;&lt;/Col&gt;
        &lt;/Row&gt;
    &lt;/div&gt;
    &lt;div class=&quot;doc-grid-row-wrap&quot;&gt;
        &lt;Row class=&quot;doc-grid-row&quot;&gt;
            &lt;Col class='doc-grid-row-col' span=&quot;16&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;16: 66.66%&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col' span=&quot;8&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;8: 33.33%&lt;/div&gt;&lt;/Col&gt;
        &lt;/Row&gt;
    &lt;/div&gt;
&lt;/template&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="LJG">
                <template slot="description"><p>通过给 <code>row</code>组件设置<code>gutter</code>属性设置列间隔，单位 <code>px</code>。</p>
</template>
                <template slot="title">列间隔 <a href="#LJG" data-title="列间隔">#</a></template>
                <template slot="source"><monkey-view-demo1 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row class=&quot;doc-grid-row&quot; :gutter=&quot;16&quot;&gt;
        &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col'&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;style&gt;
    .doc-grid-row{
        margin: 10px 0;
    }
    .doc-grid-row-col:nth-of-type(even) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
    }
    .doc-grid-col{
        padding: 30px 0;
        background-color: rgba(2,183,165, 0.8);
        color: #ffffff;
        text-align: center;
        font-size: 16px;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="ZYPY">
                <template slot="description"><p>通过给 <code>col</code>组件设置<code>offset</code>属性进行左右偏移，<code>offset</code>的值为偏移的栅格数。</p>
</template>
                <template slot="title">左右偏移 <a href="#ZYPY" data-title="左右偏移">#</a></template>
                <template slot="source"><monkey-view-demo2 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row class=&quot;doc-grid-row&quot;&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;8&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-8&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;8&quot; offset=&quot;8&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-8 | offset-8&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;

    &lt;Row class=&quot;doc-grid-row&quot;&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;6&quot; offset=&quot;8&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;6&quot; offset=&quot;4&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;

    &lt;Row class=&quot;doc-grid-row&quot;&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;12&quot; offset=&quot;8&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;style&gt;
    .doc-grid-row{
        margin: 10px 0;
    }
    .doc-grid-row-col:nth-of-type(even) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
    }
    .doc-grid-col{
        padding: 30px 0;
        background-color: rgba(2,183,165, 0.8);
        color: #ffffff;
        text-align: center;
        font-size: 16px;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="ZGPX">
                <template slot="description"><p>通过给 <code>col</code>组件设置<code>pull</code>属性和 <code>push</code>属性设置栅格排序。</p>
</template>
                <template slot="title">栅格排序 <a href="#ZGPX" data-title="栅格排序">#</a></template>
                <template slot="source"><monkey-view-demo3 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row class=&quot;doc-grid-row&quot;&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;18&quot; push=&quot;6&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-18 | push-6&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;6&quot; pull=&quot;18&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6 | push-18&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;style&gt;
    .doc-grid-row{
        margin: 10px 0;
    }
    .doc-grid-row-col:nth-of-type(even) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
    }
    .doc-grid-col{
        padding: 30px 0;
        background-color: rgba(2,183,165, 0.8);
        color: #ffffff;
        text-align: center;
        font-size: 16px;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="ZGSX">
                <template slot="description"><p>通过给 <code>col</code>组件设置<code>order</code>属性改变栅格顺序。</p>
</template>
                <template slot="title">栅格顺序 <a href="#ZGSX" data-title="栅格顺序">#</a></template>
                <template slot="source"><monkey-view-demo4 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row class=&quot;doc-grid-row&quot;&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;6&quot; order=&quot;4&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6 | order-4&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;6&quot; order=&quot;3&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6 | order-3&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;6&quot; order=&quot;2&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6 | order-2&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' span=&quot;6&quot; order=&quot;1&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-6 | order-1&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;style&gt;
    .doc-grid-row{
        margin: 10px 0;
    }
    .doc-grid-row-col:nth-of-type(even) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
    }
    .doc-grid-col{
        padding: 30px 0;
        background-color: rgba(2,183,165, 0.8);
        color: #ffffff;
        text-align: center;
        font-size: 16px;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="BJ">
                <template slot="description"><p>通过给 <code>row</code>组件设置<code>type='flex'</code>开启Flex布局，设置 <code>justify</code>属性控制水平方向的布局，设置 <code>align</code>属性控制垂直方向的布局。</p>
</template>
                <template slot="title">Flex布局 <a href="#BJ" data-title="Flex布局">#</a></template>
                <template slot="source"><monkey-view-demo5 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;div class=&quot;doc-grid-row-wrap-align&quot;&gt;
        &lt;Row class=&quot;doc-grid-row&quot; type=&quot;flex&quot; :align=&quot;alignModel&quot; :justify=&quot;justifyModel&quot;&gt;
            &lt;Col class='doc-grid-row-col' span=&quot;4&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-4&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col' span=&quot;4&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-4&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col' span=&quot;4&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-4&lt;/div&gt;&lt;/Col&gt;
            &lt;Col class='doc-grid-row-col' span=&quot;4&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col-4&lt;/div&gt;&lt;/Col&gt;
        &lt;/Row&gt;
    &lt;/div&gt;

    设置align：&lt;Select v-model=&quot;alignModel&quot; :option=&quot;alignOption&quot; class=&quot;doc-grid-flex-select&quot;&gt;&lt;/Select&gt;
    设置justify：&lt;Select v-model=&quot;justifyModel&quot; :option=&quot;justifyOption&quot; class=&quot;doc-grid-flex-select&quot;&gt;&lt;/Select&gt;
&lt;/template&gt;
&lt;script&gt;
    export default {
      data(){
        return {
          alignModel: 'top',
          alignOption: [
            {
              value: 'top',
              label: 'top'
            },
            {
              value: 'middle',
              label: 'middle'
            },
            {
              value: 'bottom',
              label: 'bottom'
            }
          ],
          justifyModel: 'start',
          justifyOption: [
            {
              value: 'start',
              label: 'start'
            },
            {
              value: 'end',
              label: 'end'
            },
            {
              value: 'center',
              label: 'center'
            },
            {
              value: 'space-around',
              label: 'space-around'
            },
            {
              value: 'space-between',
              label: 'space-between'
            }
          ]
        }
      }
    }
&lt;/script&gt;
&lt;style&gt;
    .doc-grid-row{
        margin: 10px 0;
    }
    .doc-grid-row-col:nth-of-type(even) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
        height: 80px;
    }
    .doc-grid-col{
        padding: 30px 0;
        height: 50px;
        background-color: rgba(2,183,165, 0.8);
        color: #ffffff;
        text-align: center;
        font-size: 16px;
    }
    .doc-grid-row-wrap-align{
        background-color: #eeeeee;
    }
     .doc-grid-row-col:nth-of-type(1) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
        height: 80px;
    }
    .doc-grid-row-col:nth-of-type(3) .doc-grid-col{
        height: 100px;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="XYSBJ">
                <template slot="description"><p>预设六个响应尺寸，<code>xs</code> <code>sm</code> <code>md</code> <code>lg</code> <code>xl</code> <code>xxl</code>，详细信息见API。</p>
</template>
                <template slot="title">响应式布局 <a href="#XYSBJ" data-title="响应式布局">#</a></template>
                <template slot="source"><monkey-view-demo6 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row class=&quot;doc-grid-row&quot;&gt;
        &lt;Col class='doc-grid-row-col' :xs=&quot;2&quot; :sm=&quot;8&quot; :md=&quot;4&quot; :lg=&quot;6&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' :xs=&quot;12&quot; :sm=&quot;4&quot; :md=&quot;8&quot; :lg=&quot;6&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' :xs=&quot;8&quot; :sm=&quot;4&quot; :md=&quot;8&quot; :lg=&quot;6&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col' :xs=&quot;2&quot; :sm=&quot;8&quot; :md=&quot;4&quot; :lg=&quot;6&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;style&gt;
    .doc-grid-row{
        margin: 10px 0;
    }
    .doc-grid-row-col:nth-of-type(even) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
    }
    .doc-grid-col{
        padding: 30px 0;
        background-color: rgba(2,183,165, 0.8);
        color: #ffffff;
        text-align: center;
        font-size: 16px;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<code-wrap id="QTSXDXYSBJ">
                <template slot="description"><p><code>span</code> <code>pull</code> <code>push</code> <code>offset</code> <code>order</code>属性都可以通过对象的方式设置给响应属性来使用。</p>
</template>
                <template slot="title">其他属性的响应式布局 <a href="#QTSXDXYSBJ" data-title="其他属性的响应式布局">#</a></template>
                <template slot="source"><monkey-view-demo7 /></template>
                <template slot="highlight">
<div v-highlight><pre v-pre><code class="html">&lt;template&gt;
    &lt;Row class=&quot;doc-grid-row&quot;&gt;
        &lt;Col class='doc-grid-row-col'
                :xs=&quot;{span: 2, offset: 1}&quot;
                :sm=&quot;{span: 6, offset: 1}&quot;
                :md=&quot;{span: 3, offset: 2}&quot;
                :lg=&quot;{span: 4, offset: 2}&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col'
                :xs=&quot;{span: 10, offset: 1}&quot;
                :sm=&quot;{span: 4, offset: 1}&quot;
                :md=&quot;{span: 5, offset: 2}&quot;
                :lg=&quot;{span: 4, offset: 2}&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col'
                :xs=&quot;{span: 6, offset: 1}&quot;
                :sm=&quot;{span: 4, offset: 1}&quot;
                :md=&quot;{span: 5, offset: 2}&quot;
                :lg=&quot;{span: 4, offset: 2}&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
        &lt;Col class='doc-grid-row-col'
                :xs=&quot;{span: 2, offset: 1}&quot;
                :sm=&quot;{span: 6, offset: 1}&quot;
                :md=&quot;{span: 3, offset: 2}&quot;
                :lg=&quot;{span: 4, offset: 2}&quot;&gt;&lt;div class=&quot;doc-grid-col&quot;&gt;col&lt;/div&gt;&lt;/Col&gt;
    &lt;/Row&gt;
&lt;/template&gt;
&lt;style&gt;
    .doc-grid-row{
        margin: 10px 0;
    }
    .doc-grid-row-col:nth-of-type(even) .doc-grid-col{
        background-color: rgba(2,183,165, 0.3);
    }
    .doc-grid-col{
        padding: 30px 0;
        background-color: rgba(2,183,165, 0.8);
        color: #ffffff;
        text-align: center;
        font-size: 16px;
    }
&lt;/style&gt;

</code></pre></div></template></code-wrap>
<h2 id="api" class="anchor-title">API <a class="header-anchor" href="#api">#</a></h2>
<h3 id="row-props" class="anchor-title">Row props <a class="header-anchor" href="#row-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>type</td>
<td>String</td>
<td>布局方式，可选值<code>flex</code></td>
<td>-</td>
</tr>
<tr>
<td>align</td>
<td>String</td>
<td><code>flex</code> 布局下的垂直对齐方式，可选值为 <code>top</code>、<code>middle</code>、<code>bottom</code></td>
<td>-</td>
</tr>
<tr>
<td>justify</td>
<td>String</td>
<td><code>flex</code> 布局下的水平对齐方式，可选值为 <code>start</code>、<code>end</code>、<code>center</code>、<code>space-around</code>、<code>space-between</code></td>
<td>-</td>
</tr>
<tr>
<td>gutter</td>
<td>Number</td>
<td>栅格间隔</td>
<td>0</td>
</tr>
</tbody>
</table>
<h3 id="col-props" class="anchor-title">Col props <a class="header-anchor" href="#col-props">#</a></h3>
<table class="doc-table"><thead>
<tr>
<th>属性</th>
<th>类型</th>
<th>说明</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>span</td>
<td>Number, String</td>
<td>占位格数，<code>0~24</code>的整数，0时相当于<code>display:none</code></td>
<td>-</td>
</tr>
<tr>
<td>order</td>
<td>Number, String</td>
<td>排序顺序，<code>flex</code>模式下有效</td>
<td>-</td>
</tr>
<tr>
<td>offset</td>
<td>Number, String</td>
<td>栅格左侧的间隔格数，间隔内不可以有栅格</td>
<td>-</td>
</tr>
<tr>
<td>push</td>
<td>Number, String</td>
<td>栅格向右移动格数</td>
<td>-</td>
</tr>
<tr>
<td>pull</td>
<td>Number, String</td>
<td>栅格向左移动格数</td>
<td>-</td>
</tr>
<tr>
<td>xs</td>
<td>Number, Object</td>
<td><code>&lt;576px</code>响应式栅格，可为栅格数或一个包含其他属性的对象,如：<code>{span: 2, offset: 1}</code></td>
<td>-</td>
</tr>
<tr>
<td>sm</td>
<td>Number, Object</td>
<td><code>&gt;=576px</code>响应式栅格，可为栅格数或一个包含其他属性的对象,如：<code>{span: 2, offset: 1}</code></td>
<td>-</td>
</tr>
<tr>
<td>md</td>
<td>Number, Object</td>
<td><code>&gt;=768px</code>响应式栅格，可为栅格数或一个包含其他属性的对象,如：<code>{span: 2, offset: 1}</code></td>
<td>-</td>
</tr>
<tr>
<td>lg</td>
<td>Number, Object</td>
<td><code>&gt;=992px</code>响应式栅格，可为栅格数或一个包含其他属性的对象,如：<code>{span: 2, offset: 1}</code></td>
<td>-</td>
</tr>
<tr>
<td>xl</td>
<td>Number, Object</td>
<td><code>&gt;=1200px</code>响应式栅格，可为栅格数或一个包含其他属性的对象,如：<code>{span: 2, offset: 1}</code></td>
<td>-</td>
</tr>
<tr>
<td>xxl</td>
<td>Number, Object</td>
<td><code>&gt;=1920px</code>响应式栅格，可为栅格数或一个包含其他属性的对象,如：<code>{span: 2, offset: 1}</code></td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "monkey-view-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"doc-grid-row-wrap"},[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("24: 100%")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"doc-grid-row-wrap"},[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("12: 50%")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("12: 50%")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"doc-grid-row-wrap"},[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("8: 33.33%")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("8: 33.33%")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("8: 33.33%")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"doc-grid-row-wrap"},[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("6: 25%")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("6: 25%")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("6: 25%")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("6: 25%")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"doc-grid-row-wrap"},[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"16"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("16: 66.66%")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"8"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("8: 33.33%")])])],1)],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{staticClass:"doc-grid-row",attrs:{"gutter":16}},[_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col"},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo2": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"8"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-8")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"8","offset":"8"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-8 | offset-8")])])],1),_vm._v(" "),_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"6","offset":"8"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"6","offset":"4"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6")])])],1),_vm._v(" "),_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"12","offset":"8"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo3": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"18","push":"6"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-18 | push-6")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"6","pull":"18"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6 | push-18")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo4": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"6","order":"4"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6 | order-4")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"6","order":"3"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6 | order-3")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"6","order":"2"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6 | order-2")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"6","order":"1"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-6 | order-1")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo5": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"doc-grid-row-wrap-align"},[_c('Row',{staticClass:"doc-grid-row",attrs:{"type":"flex","align":_vm.alignModel,"justify":_vm.justifyModel}},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"4"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-4")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"4"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-4")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"4"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-4")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"span":"4"}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col-4")])])],1)],1),_vm._v("\n\n    设置align："),_c('Select',{staticClass:"doc-grid-flex-select",attrs:{"option":_vm.alignOption},model:{value:(_vm.alignModel),callback:function ($$v) {_vm.alignModel=$$v},expression:"alignModel"}}),_vm._v("\n    设置justify："),_c('Select',{staticClass:"doc-grid-flex-select",attrs:{"option":_vm.justifyOption},model:{value:(_vm.justifyModel),callback:function ($$v) {_vm.justifyModel=$$v},expression:"justifyModel"}})]],2)}
var staticRenderFns = []

  
    const democomponentExport = {
      data(){
        return {
          alignModel: 'top',
          alignOption: [
            {
              value: 'top',
              label: 'top'
            },
            {
              value: 'middle',
              label: 'middle'
            },
            {
              value: 'bottom',
              label: 'bottom'
            }
          ],
          justifyModel: 'start',
          justifyOption: [
            {
              value: 'start',
              label: 'start'
            },
            {
              value: 'end',
              label: 'end'
            },
            {
              value: 'center',
              label: 'center'
            },
            {
              value: 'space-around',
              label: 'space-around'
            },
            {
              value: 'space-between',
              label: 'space-between'
            }
          ]
        }
      }
    }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo6": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":2,"sm":8,"md":4,"lg":6}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":12,"sm":4,"md":8,"lg":6}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":8,"sm":4,"md":8,"lg":6}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":2,"sm":8,"md":4,"lg":6}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"monkey-view-demo7": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('Row',{staticClass:"doc-grid-row"},[_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":{span: 2, offset: 1},"sm":{span: 6, offset: 1},"md":{span: 3, offset: 2},"lg":{span: 4, offset: 2}}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":{span: 10, offset: 1},"sm":{span: 4, offset: 1},"md":{span: 5, offset: 2},"lg":{span: 4, offset: 2}}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":{span: 6, offset: 1},"sm":{span: 4, offset: 1},"md":{span: 5, offset: 2},"lg":{span: 4, offset: 2}}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])]),_vm._v(" "),_c('Col',{staticClass:"doc-grid-row-col",attrs:{"xs":{span: 2, offset: 1},"sm":{span: 6, offset: 1},"md":{span: 3, offset: 2},"lg":{span: 4, offset: 2}}},[_c('div',{staticClass:"doc-grid-col"},[_vm._v("col")])])],1)]],2)}
var staticRenderFns = []

  
    const democomponentExport = {}
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  